module.exports = (theme) => ({
  ".heading-block": {
    maxWidth: theme("screens.xl"),
    marginTop: theme("spacing.2xl"),
    marginBottom: theme("spacing.xl"),
    marginLeft: "auto",
    marginRight: "auto",
  },
  ".heading-block h1, .heading-block h2, .heading-block h3, heading-block h4": {
    paddingLeft: "21px",
    paddingRight: "21px",
  },
  ".heading-block h1, .heading-block h2.h1": { paddingTop: theme("spacing.2xl") },
  ".heading-block h2": { paddingTop: theme("spacing.xl") },
  ".heading-block h3": { paddingTop: theme("spacing.lg") },
  ".heading-block h4": { paddingTop: theme("spacing.DEFAULT") },

  [`@media (max-width: ${theme("screens.xs")})`]: {
    ".heading-block": {
      marginTop: theme("spacing.xl"),
      marginBottom: theme("spacing.DEFAULT"),
      marginLeft: "auto",
      marginRight: "auto",
    },
    ".heading-block h1": { paddingTop: theme("spacing.xl") },
    ".heading-block h2": { paddingTop: theme("spacing.lg") },
    ".heading-block h3": { paddingTop: theme("spacing.DEFAULT") },
    ".heading-block h4": { paddingTop: theme("spacing.sm") },
  },
});
